import { apiGet, apiPost, apiPatch, apiDelete } from '../api';
import { baseUrl, audience } from '../api/helpers';
import axios from 'axios';

// Get all custom columns for a dashboard
const getCustomColumns = async (token, dashboardId) => {
  const url = `dashboards/${dashboardId}/custom_columns`;
  const data = await apiGet({ url, token });
  return data;
};

// Create a new custom column
const createCustomColumn = async (token, dashboardId, params) => {
  const url = `dashboards/${dashboardId}/custom_columns`;
  const objectName = 'custom_column';
  const data = await apiPost({ url, token, objectName, params });
  return data;
};

// Update a custom column
const updateCustomColumn = async (token, columnId, params) => {
  const url = `custom_columns/${columnId}`;
  const objectName = 'custom_column';
  const data = await apiPatch({ url, token, objectName, params });
  return data;
};

// Delete a custom column
const deleteCustomColumn = async (token, columnId) => {
  const url = `custom_columns/${columnId}`;
  await apiDelete({ url, token });
};

// Reorder custom columns
const reorderCustomColumns = async (token, dashboardId, columnOrders) => {
  const url = `dashboards/${dashboardId}/custom_columns/reorder`;
  const objectName = 'column_orders';
  await apiPatch({ url, token, objectName, params: columnOrders });
};

// Get custom column values for transactions
const getCustomColumnValues = async (token, dashboardId, transactionIds) => {
  const url = `dashboards/${dashboardId}/custom_column_values`;
  // Convert array to comma-separated string for URL params
  const transaction_ids = Array.isArray(transactionIds) ? transactionIds.join(',') : transactionIds;
  const params = { transaction_ids };
  const data = await apiGet({ url, token, params });
  return data;
};

// Update a single custom column value
const updateCustomColumnValue = async (token, valueId, value) => {
  const url = `custom_column_values/${valueId}`;
  const objectName = 'value';
  const data = await apiPatch({ url, token, objectName, params: value });
  return data;
};

// Upsert a custom column value
const upsertCustomColumnValue = async (token, dashboardId, params) => {
  const url = `dashboards/${dashboardId}/custom_column_values/upsert`;
  const fullUrl = `${baseUrl}/${url}`;
  // For upsert, we send params directly without object wrapping
  const jsonParams = JSON.stringify(params);

  const data = await axios
    .post(fullUrl, jsonParams, {
      audience,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
      return response.data;
    });

  return data;
};

// Batch update custom column values
const batchUpdateCustomColumnValues = async (token, dashboardId, updates) => {
  const url = `dashboards/${dashboardId}/custom_column_values/batch_update`;
  const objectName = 'updates';
  const data = await apiPatch({ url, token, objectName, params: updates });
  return data;
};

// Get custom columns grouped by section for a user
const getCustomColumnsBySection = async (token, userId) => {
  const url = `users/${userId}/custom_columns_by_section`;
  const data = await apiGet({ url, token });
  return data;
};

export const customColumnService = {
  getCustomColumns,
  createCustomColumn,
  updateCustomColumn,
  deleteCustomColumn,
  reorderCustomColumns,
  getCustomColumnValues,
  updateCustomColumnValue,
  upsertCustomColumnValue,
  batchUpdateCustomColumnValues,
  getCustomColumnsBySection
};

export default customColumnService;